import React, { useEffect } from 'react';
import { Chart } from '@antv/g2';


const NationalTransactionsChart = ({ lastWeek }) => {
  const nationalTransactionsChart = () => {
    const chart = new Chart({
      container: 'national-transactions-chart',
      height: 100,
      autoFit: true
    });

    const formattedData = lastWeek?.map((item, index) => ({
      month: item.month,
      type: item.type,
      count: item.count,
      color: index % 2 === 0 ? '#F4A261' : '#6950E8',
    }));

    chart
      .interval()
      .data(formattedData)
      .encode('x', 'month')
      .encode('y', 'count')
      .encode('color', 'color')
      .encode('series', 'type')
      .scale('color', { type: 'identity' })
      .scale('x', { paddingOuter: -10 })
      .legend(false)
      .axis(false)
      .encode('size', 20)
      .style('radiusTopLeft', 20)
      .style('radiusTopRight', 20)
      .tooltip((data) => ({
        name: data.type,
        value:  new Intl.NumberFormat('es-AR', {
          style: 'currency',
          currency: 'ARS',
        }).format(data.count),
      }));

    chart.render();
  }

  useEffect(() => {
    nationalTransactionsChart();
  }, [lastWeek]);

  return (
    <div id={'national-transactions-chart'} />
  )
}

export default NationalTransactionsChart;